(async function () {
  const root = document.getElementById("bookshops-app");
  if (!root) return;

  const domain = root.dataset.shopDomain;
  const token = root.dataset.storefrontToken;
  const apiVersion = root.dataset.apiVersion || "2026-01";

  if (!domain || !token) {
    root.innerHTML = "<p>Configuration missing (shop domain or storefront token).</p>";
    return;
  }

  const endpoint = `https://${domain}/api/${apiVersion}/graphql.json`;

  const query = `
    query GetBookshops($cursor: String) {
      metaobjects(type: "bookshop", first: 250, after: $cursor) {
        edges {
          node {
            id
            fields {
              key
              value
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  `;

  async function fetchPage(cursor) {
    const res = await fetch(endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": token
      },
      body: JSON.stringify({ query, variables: { cursor } })
    });

    const json = await res.json();
    if (!res.ok || json.errors) {
      throw new Error(JSON.stringify(json.errors || json));
    }
    return json.data.metaobjects;
  }

  function toObject(node) {
    const obj = {};
    for (const f of node.fields) obj[f.key] = f.value;
    return obj;
  }

  try {
    root.innerHTML = "<p>Loading…</p>";

    let cursor = null;
    let hasNext = true;
    const items = [];

    while (hasNext) {
      const data = await fetchPage(cursor);
      for (const edge of data.edges) items.push(toObject(edge.node));
      hasNext = data.pageInfo.hasNextPage;
      cursor = data.pageInfo.endCursor;
    }

    // Tri : pays, ville, titre
    items.sort((a, b) =>
      (a.country || "").localeCompare(b.country || "") ||
      (a.city || "").localeCompare(b.city || "") ||
      (a.title || "").localeCompare(b.title || "")
    );

    // Render en reprenant votre markup (row/col-*)
    root.innerHTML = `
      <div class="bookshops__list">
        ${items.map(s => `
          <a href="${s.url || "#"}" target="_blank" class="row" rel="noopener noreferrer">
            <div class="col-6">${escapeHtml(s.title || "")}</div>
            <div class="col-3">${escapeHtml(s.city || "")}</div>
            <div class="col-2">${escapeHtml(s.country || "")}</div>
            <div class="col-1 bookshop-arrow">&rarr;</div>
          </a>
        `).join("")}
      </div>
    `;
  } catch (e) {
    root.innerHTML = `<p>Failed to load bookshops.</p>`;
    console.error(e);
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }
})();
